import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "crm-dashboard" }
const _hoisted_2 = { class: "nav-menu" }
const _hoisted_3 = { class: "nav-label" }
const _hoisted_4 = { class: "stat-card-inner" }
const _hoisted_5 = { class: "stat-top-row" }
const _hoisted_6 = { class: "stat-main-content" }
const _hoisted_7 = { class: "stat-value-mini" }
const _hoisted_8 = { class: "stat-label-mini" }
const _hoisted_9 = {
  key: 0,
  class: "stat-footer-mini"
}
const _hoisted_10 = { class: "d-flex align-center" }
const _hoisted_11 = { class: "chart-filters d-flex align-center" }
const _hoisted_12 = { class: "pipeline-stages" }
const _hoisted_13 = { class: "stage-header" }
const _hoisted_14 = { class: "stage-name" }
const _hoisted_15 = { class: "stage-count" }
const _hoisted_16 = { class: "stage-bar" }
const _hoisted_17 = { class: "stage-value" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "activity-header" }
const _hoisted_20 = { class: "activity-time" }
const _hoisted_21 = { class: "activity-footer d-flex align-center mt-1" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "activity-description" }
const _hoisted_24 = { class: "d-flex align-center" }
const _hoisted_25 = { class: "chart-filters d-flex align-center" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "opp-title-cell" }
const _hoisted_28 = { class: "opp-name" }
const _hoisted_29 = { class: "opp-value" }
const _hoisted_30 = { class: "opp-date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_DxDateBox = _resolveComponent("DxDateBox")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_timeline_item = _resolveComponent("v-timeline-item")!
  const _component_v_timeline = _resolveComponent("v-timeline")!
  const _component_DxLabel = _resolveComponent("DxLabel")!
  const _component_DxArgumentAxis = _resolveComponent("DxArgumentAxis")!
  const _component_DxSeries = _resolveComponent("DxSeries")!
  const _component_DxValueAxis = _resolveComponent("DxValueAxis")!
  const _component_DxLegend = _resolveComponent("DxLegend")!
  const _component_DxTooltip = _resolveComponent("DxTooltip")!
  const _component_DxChart = _resolveComponent("DxChart")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      class: "nav-menu-card",
      elevation: "2"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item, index) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: index,
              to: item.route,
              class: _normalizeClass(["nav-item", { 'active': _ctx.isActiveRoute(item.route) }])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  color: _ctx.isActiveRoute(item.route) ? _ctx.APP_Color : '#718096',
                  size: "20"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.icon), 1)
                  ]),
                  _: 2
                }, 1032, ["color"]),
                _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1)
              ]),
              _: 2
            }, 1032, ["to", "class"]))
          }), 128))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, {
      class: "stats-row",
      dense: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats, (stat, index) => {
          return (_openBlock(), _createBlock(_component_v_col, {
            key: index,
            cols: "12",
            sm: "6",
            md: "3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: _normalizeClass(["stat-card", `stat-${stat.id || index}`]),
                elevation: "1",
                onClick: ($event: any) => (_ctx.$router.push(stat.route)),
                style: {"cursor":"pointer"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", {
                        class: "stat-icon-mini",
                        style: _normalizeStyle({ background: stat.bgColor })
                      }, [
                        _createVNode(_component_v_icon, {
                          color: stat.color,
                          size: "18"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(stat.icon), 1)
                          ]),
                          _: 2
                        }, 1032, ["color"])
                      ], 4),
                      (stat.change && stat.change !== '+0%')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["stat-trend-mini", stat.trend])
                          }, [
                            _createVNode(_component_v_icon, { size: "12" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(stat.trend === 'up' ? 'mdi-arrow-up' : stat.trend === 'down' ? 'mdi-arrow-down' :
                  'mdi-minus'), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createElementVNode("span", null, _toDisplayString(stat.change.split(' ')[0]), 1)
                          ], 2))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(stat.value), 1),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(stat.label), 1)
                    ]),
                    (stat.change && stat.change.includes('|'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(stat.change.split('|')[1].trim()), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1032, ["class", "onClick"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "charts-row" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "7"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: "chart-card",
              elevation: "2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "card-title justify-space-between" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_v_icon, {
                        color: _ctx.APP_Color,
                        size: "24",
                        class: "mr-2"
                      }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode("mdi-chart-line", -1)
                        ]))]),
                        _: 1
                      }, 8, ["color"]),
                      _cache[5] || (_cache[5] = _createElementVNode("span", null, "Pipeline Vânzări", -1))
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_DxDateBox, {
                        value: _ctx.pipelineStartDate,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pipelineStartDate) = $event)),
                        type: "date",
                        "display-format": "dd/MM/yyyy",
                        width: "115",
                        class: "premium-date-box",
                        onValueChanged: _ctx.refreshPipeline
                      }, null, 8, ["value", "onValueChanged"]),
                      _cache[6] || (_cache[6] = _createElementVNode("span", { class: "filter-separator" }, "-", -1)),
                      _createVNode(_component_DxDateBox, {
                        value: _ctx.pipelineEndDate,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pipelineEndDate) = $event)),
                        type: "date",
                        "display-format": "dd/MM/yyyy",
                        width: "115",
                        class: "premium-date-box",
                        onValueChanged: _ctx.refreshPipeline
                      }, null, 8, ["value", "onValueChanged"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pipelineStages, (stage, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "pipeline-stage"
                        }, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("span", _hoisted_14, _toDisplayString(stage.name), 1),
                            _createElementVNode("span", _hoisted_15, _toDisplayString(stage.count), 1)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", {
                              class: "stage-progress",
                              style: _normalizeStyle({
                    width: stage.percentage + '%',
                    background: stage.color
                  })
                            }, null, 4)
                          ]),
                          _createElementVNode("div", _hoisted_17, _toDisplayString(stage.value) + " EUR", 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "5"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: "activity-card",
              elevation: "2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "card-title" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      color: _ctx.APP_Color,
                      size: "24",
                      class: "mr-2"
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode("mdi-clock-outline", -1)
                      ]))]),
                      _: 1
                    }, 8, ["color"]),
                    _cache[8] || (_cache[8] = _createElementVNode("span", null, "Activități Recente", -1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, { class: "pa-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_timeline, {
                      side: "end",
                      density: "compact",
                      class: "activity-timeline"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentActivities, (activity, index) => {
                          return (_openBlock(), _createBlock(_component_v_timeline_item, {
                            key: index,
                            "dot-color": activity.color,
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["activity-content", { 'clickable-activity': activity.opportunityId }]),
                                onClick: ($event: any) => (activity.opportunityId ? _ctx.goToOpportunity(activity.opportunityId) : null)
                              }, [
                                _createElementVNode("div", _hoisted_19, [
                                  _createElementVNode("span", _hoisted_20, _toDisplayString(activity.time), 1)
                                ]),
                                _createElementVNode("div", _hoisted_21, [
                                  (activity.tag)
                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                        key: 0,
                                        size: "x-small",
                                        color: activity.tagColor,
                                        class: "mr-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(activity.tag), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["color"]))
                                    : _createCommentVNode("", true),
                                  (activity.opportunity)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 1,
                                        class: "activity-opp-link",
                                        onClick: ($event: any) => (_ctx.goToOpportunity(activity.opportunityId))
                                      }, [
                                        _createVNode(_component_v_icon, {
                                          size: "12",
                                          class: "mr-1"
                                        }, {
                                          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                            _createTextVNode("mdi-briefcase-outline", -1)
                                          ]))]),
                                          _: 1
                                        }),
                                        _createTextVNode(" " + _toDisplayString(activity.opportunity), 1)
                                      ], 8, _hoisted_22))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_23, _toDisplayString(activity.description), 1)
                              ], 10, _hoisted_18)
                            ]),
                            _: 2
                          }, 1032, ["dot-color"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "charts-row" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: "chart-card",
              elevation: "2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "card-title justify-space-between" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_v_icon, {
                        color: _ctx.APP_Color,
                        size: "24",
                        class: "mr-2"
                      }, {
                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                          _createTextVNode("mdi-chart-bar", -1)
                        ]))]),
                        _: 1
                      }, 8, ["color"]),
                      _cache[11] || (_cache[11] = _createElementVNode("span", null, "Prognoză Buget", -1))
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_DxDateBox, {
                        value: _ctx.chartStartDate,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.chartStartDate) = $event)),
                        type: "date",
                        "display-format": "dd/MM/yyyy",
                        width: "115",
                        class: "premium-date-box",
                        onValueChanged: _ctx.refreshChart
                      }, null, 8, ["value", "onValueChanged"]),
                      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "filter-separator" }, "-", -1)),
                      _createVNode(_component_DxDateBox, {
                        value: _ctx.chartEndDate,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.chartEndDate) = $event)),
                        type: "date",
                        "display-format": "dd/MM/yyyy",
                        width: "115",
                        class: "premium-date-box",
                        onValueChanged: _ctx.refreshChart
                      }, null, 8, ["value", "onValueChanged"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxChart, {
                      "data-source": _ctx.monthlySalesData,
                      rotated: false,
                      title: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxArgumentAxis, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxLabel, {
                              rotated: true,
                              "rotation-angle": "45"
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_DxSeries, {
                          "argument-field": "month",
                          "value-field": "value",
                          name: "Valoare Ponderată",
                          type: "bar",
                          color: "#9C27B0"
                        }),
                        _createVNode(_component_DxValueAxis, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxLabel, { visible: true })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_DxLegend, { visible: false }),
                        _createVNode(_component_DxTooltip, {
                          enabled: true,
                          shared: true,
                          "customize-tooltip": (arg) => {
                return {
                  text: arg.argumentText + ': ' + _ctx.formatCurrency(arg.originalValue)
                };
              }
                        }, null, 8, ["customize-tooltip"])
                      ]),
                      _: 1
                    }, 8, ["data-source"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "bottom-row" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: "activity-card",
              elevation: "2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "card-title" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      color: _ctx.APP_Color,
                      size: "24",
                      class: "mr-2"
                    }, {
                      default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                        _createTextVNode("mdi-briefcase-outline", -1)
                      ]))]),
                      _: 1
                    }, 8, ["color"]),
                    _cache[14] || (_cache[14] = _createElementVNode("span", null, "Oportunități Noi", -1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, { class: "pa-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_table, { class: "dashboard-table" }, {
                      default: _withCtx(() => [
                        _cache[16] || (_cache[16] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", { class: "text-left" }, "Oportunitate"),
                            _createElementVNode("th", { class: "text-left" }, "Partener"),
                            _createElementVNode("th", { class: "text-left" }, "Valoare"),
                            _createElementVNode("th", { class: "text-left" }, "Status"),
                            _createElementVNode("th", { class: "text-left" }, "Data")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentOpportunities, (opp, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: index,
                              class: "clickable-row",
                              onClick: ($event: any) => (_ctx.goToOpportunity(opp.id))
                            }, [
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_27, [
                                  _createVNode(_component_v_icon, {
                                    size: "18",
                                    color: "primary",
                                    class: "mr-2"
                                  }, {
                                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                      _createTextVNode("mdi-briefcase-variant", -1)
                                    ]))]),
                                    _: 1
                                  }),
                                  _createElementVNode("span", _hoisted_28, _toDisplayString(opp.title), 1)
                                ])
                              ]),
                              _createElementVNode("td", null, _toDisplayString(opp.company), 1),
                              _createElementVNode("td", _hoisted_29, _toDisplayString(opp.value) + " EUR", 1),
                              _createElementVNode("td", null, [
                                _createVNode(_component_v_chip, {
                                  color: _ctx.getStatusColor(opp.status),
                                  size: "x-small",
                                  label: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(opp.status), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["color"])
                              ]),
                              _createElementVNode("td", _hoisted_30, _toDisplayString(opp.dateFormatted), 1)
                            ], 8, _hoisted_26))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { class: "bottom-row" })
  ]))
}